import { Provider } from "risa-data-model";
import { AuthStatusOptionModel } from "../../../data-model/authStatusOptions";
import { BOOptionModel } from "../../../data-model/boOptionModel";
import { FilterSection } from "../../../data-model/filterValues";
import { FilterCreationConfig } from "./filterCreationConfig";

interface FilterDataBuilderParams {
  algoliaMultiFacetsCount: any;
  authStatusOptions: AuthStatusOptionModel[];
  boOptions: BOOptionModel[];
  allProvidersDetails: Provider[];
  filterCreationConfig: FilterCreationConfig[];
}

/**
 * Builds the complete filter data array from various data sources
 * Uses configuration-driven approach for better maintainability
 */
export const buildFilterData = ({
  algoliaMultiFacetsCount,
  authStatusOptions,
  boOptions,
  allProvidersDetails,
  filterCreationConfig,
}: FilterDataBuilderParams): FilterSection[] => {
  const dataMap = {
    boStatus: boOptions ?? [],
    authStatus: authStatusOptions ?? [],
    assignee: allProvidersDetails ?? [],
  };

  return filterCreationConfig.map((config) => {
    if (!config.requiresData) {
      return config.createFunction();
    }

    let data: any;
    if (config.dataExtractor) {
      data = config.dataExtractor(algoliaMultiFacetsCount);
    } else if (dataMap[config.id as keyof typeof dataMap]) {
      data = dataMap[config.id as keyof typeof dataMap];
    }

    return config.createFunction(data);
  });
};

/**
 * Checks if all required data is available for building filters
 */
export const areFilterDependenciesReady = ({
  algoliaMultiFacetsCount,
  authStatusOptions,
  boOptions,
  providerDetails,
  filterCreationConfig,
}: Omit<
  FilterDataBuilderParams,
  "allProvidersDetails" | "filterCreationConfig"
> & {
  providerDetails: any;
  filterCreationConfig: FilterCreationConfig[];
}): boolean => {
  return !!(
    algoliaMultiFacetsCount &&
    authStatusOptions &&
    authStatusOptions.length > 0 &&
    boOptions &&
    boOptions.length > 0 &&
    providerDetails &&
    filterCreationConfig &&
    filterCreationConfig.length > 0
  );
};
